import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLogin } from '@games/api';
import { HelmetTitle } from '../helmet';
import messages from 'intl/messages';
import { LoginForm, LoginFormFields } from './LoginForm';
import { selectAuthUser, setAuthUser } from './auth-slice';
import { useDispatch } from 'react-redux';

export const LoginPage: React.FC = () => {
  const [{ data: result, loading, error }, login] = useLogin();
  const me = useSelector(selectAuthUser);
  const dispatch = useDispatch();
  const { locale, formatMessage } = useIntl();

  useEffect(() => {
    if (result && result.token) {
      dispatch(setAuthUser(result));
    }
  }, [result, dispatch]);

  if (me && me.token) {
    return (
      <div className='text-center'>
        <HelmetTitle message={formatMessage(messages.loggedIn)} />
        <FormattedMessage {...messages.loggedIn} />
      </div>
    );
  }

  const submit = (data: LoginFormFields) => {
    login({ data });
  };

  return (
    <div className='container mx-auto'>
      <HelmetTitle message={formatMessage(messages.login)} />
      <h2 className='text-center text-2xl mb-4 font-bold'>
        <FormattedMessage {...messages.login} />
      </h2>
      <LoginForm
        onSubmit={submit}
        loading={loading}
      />
      {error && (
        <div className='text-center'>
          There was a problem. Please try again.
        </div>
      )}
      {result && result.token === null && (
        <div className='text-center'>
          The username/password is not recognized.
          <br />
          Please check and try again.
        </div>
      )}
      <div className='mt-4'>
        <div className='text-center text-lg font-bold'>
          <FormattedMessage {...messages.noAccount} />
        </div>
        <div className='text-center'>
          <a href={`/${locale}/register`}>
            <FormattedMessage {...messages.createAccount} />
          </a>
        </div>
      </div>
    </div>
  );
};
